import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyle = styled(Box)(({ theme }) => ({
  width: '100vw',
  height: '100vh',
  backgroundColor: theme.palette.root.mainLightGrey
}));
